import React, { useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'

import Chats from '../../../../../presentation/pages/common/chats'

import { useMe } from '../../../../../presentation/contexts/me'
import useFetchConversations from '../../../../../presentation/hooks/fetch-conversations'
import useInterlocutors from '../../../../../presentation/hooks/interlocutors'

import { makeDoctors } from '../../../../usecases/doctors/remote-doctors-factory'

import { RoutesEnum, Authority } from '../../../../../presentation/enums'
import { getRoute } from '../../../../../presentation/helpers'

const MakeChatsContractor = () => {
  document.title = 'BuscarMédicos - Conversas'

  const [search, setSearch] = useState('')

  const history = useHistory()

  const { me } = useMe()

  const conversations = useFetchConversations(me?.id)

  // eslint-disable-next-line max-len
  const { interlocutors, setInterlocutors, fetchInterlocutors } = useInterlocutors(makeDoctors, conversations)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }

  const handleSearch = () => {
    if (search === '') {
      fetchInterlocutors()

      return null
    }

    const filteredInterlocutors = interlocutors.filter((interlocutor) => {
      const firstName = interlocutor.firstName.toLowerCase()
      const searchValue = search.toLowerCase()

      return firstName.includes(searchValue)
    })

    setInterlocutors(filteredInterlocutors)

    setSearch('')

    return null
  }

  const handleChatClick = (id: number) => {
    history.push(
      getRoute(RoutesEnum.CHAT, {
        interlocutorType: Authority.DOCTOR,
        interlocutorId: String(id),
      }),
    )
  }

  useEffect(() => {
    fetchInterlocutors()
  }, [conversations, fetchInterlocutors])

  const receivedMessages = conversations.map((conversation) => {
    const receivedMessagesFiltered = conversation.messages.filter(
      (message) => message.receiverId === String(me?.id),
    )

    return receivedMessagesFiltered
  })

  const lastReceivedMessages = receivedMessages.map(
    (receivedMessagesInConversation) => receivedMessagesInConversation[0],
  )

  const resource = interlocutors.map((interlocutor) => {
    const lastReceivedMessage = lastReceivedMessages.find(
      (message) => message?.senderId === String(interlocutor.id),
    )

    return {
      id: interlocutor.id,
      title: interlocutor.firstName,
      lastMessage: lastReceivedMessage?.message || '',
      lastMessageDate: lastReceivedMessage?.sendingDate || null,
      hasNewMessage: !lastReceivedMessage?.isRead || false,
    }
  })

  const chatProps = {
    states: {
      resource,
      search,
    },
    handlers: {
      handleChange,
      handleSearch,
      handleChatClick,
    },
  }

  return <Chats {...chatProps} />
}

export default MakeChatsContractor
